module.exports = __webpack_public_path__ + "static/media/heliosCercle.52d1b346.JPG";